<template>
    <a
        v-on:click.prevent="$emit('click')"
        class="textpicker-button"
        href="#"
        v-tooltip="'Textvorlage auswählen'"
    >
        <img
            class="textpicker-button__image"
            src="/files/static/ui/icons/icon_textblocks.svg"
            ref="svginject"
            alt="Textvorlage auswählen"
    /></a>
</template>

<script>
import SVGInject from '@iconfu/svg-inject';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {},
    computed: {},
    created() {},
    props: {},
    mounted() {
        SVGInject(this.$refs.svginject);
    }
};
</script>
